import { createReducer } from "@reduxjs/toolkit";
import {
  createNotificationThunk,
  getHunterCompanyThunk,
  getHunterEmployeeThunk,
} from "../actions/admin.action";
import { HunterCompanyDto } from "../../models/admin.model";

export interface MarketingState {
  loading: boolean;
  hunterCompanyData: HunterCompanyDto[];
  hunterEmployeeData: any;
  error: string | null;
}

const initialState: MarketingState = {
  loading: false,
  hunterCompanyData: [],
  hunterEmployeeData: {},
  error: null,
};

const MarketingReducer = createReducer(initialState, (builder) => {
  // Hunter Search
  builder
    .addCase(getHunterCompanyThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getHunterCompanyThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.hunterCompanyData = action.payload.data;
      state.error = null;
    })
    .addCase(getHunterCompanyThunk.rejected, (state, action) => {
      state.loading = false;
      state.error =
        (action.payload as string) || "Failed to fetch hunter company data";
    });
  // Hunter Company
  builder
    .addCase(getHunterEmployeeThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getHunterEmployeeThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.hunterEmployeeData = action.payload.data;
      state.error = null;
    })
    .addCase(getHunterEmployeeThunk.rejected, (state, action) => {
      state.loading = false;
      state.error =
        (action.payload as string) || "Failed to fetch hunter company data";
    });
  // Create Notification
  builder
    .addCase(createNotificationThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(createNotificationThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
    })
    .addCase(createNotificationThunk.rejected, (state, action) => {
      state.loading = false;
      state.error =
        (action.payload as string) || "Failed to create notification";
    });
});

export default MarketingReducer;
